export const DEFAULT_MAP_ZOOM = 16;
export const STANDALONE_MAP_ZOOM = 17;
export const SKIP_MARKERS_REPAINT_KEYS = [ 'mapBounds', 'selectedNewBuildingId' ];
